import React, { useEffect, useState } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import Editbtn from "../Skills/images/circum_edit.svg";
import { Pagination } from "react-bootstrap";
import deletebtn from "../Skills/images/material-symbols-light_delete-outline.svg";
import { baseURL } from "../../config";

const SubCategoryTable = () => {
  const [posts, setPosts] = useState({ subcategories: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [editedsubcateory, setEditedSubcategory] = useState(null);

  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [subcategoryToDelete, setSubcategoryToDelete] = useState(null);

  useEffect(() => {
    const fetchPostList = async () => {
      try {
        const { data } = await axios(`${baseURL}/getsubcategories`);
        console.log("Fetched data:", data);
        if (Array.isArray(data.subcategories)) {
          setPosts({ subcategories: data.subcategories });
        } else {
          console.error("Data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPostList();
  }, []);

  const handleDelete = async (subcategoriesId) => {
    try {
      setSubcategoryToDelete(subcategoriesId);
      setShowDeleteModal(true);
    } catch (error) {
      console.error("Error deleting category:", error);
    }
  };

  const handleSaveEditedSubcategory = async () => {
    try {
      const response = await axios.post(
        `${baseURL}/subcategoryupdate?id=${editedsubcateory.id}`,
        editedsubcateory
      );
      console.log("Updated Subcategory:", response.data);
      // Update the state with the updated grade
      const updatedSubCatory = posts.subcategories.map((subcategories) => {
        if (subcategories.id === editedsubcateory.id) {
          return editedsubcateory;
        }
        return subcategories;
      });
      setPosts({ subcategories: updatedSubCatory });
      setShowEditModal(false);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.error("Grade not found. Please try again.");
      } else {
        console.error("Error updating Grade:", error);
      }
    }
  };

  const confirmDelete = async () => {
    try {
      await axios.get(
        `${baseURL}/deletesubcategory?id=${subcategoryToDelete}`
      );
      const updatedSubCatory = posts.subcategories.filter(
        (subcategories) => subcategories.id !== subcategoryToDelete
      );
      setPosts({ subcategories: updatedSubCatory });
      setShowDeleteModal(false);
    } catch (error) {
      console.error("Error deleting Grade:", error);
    }
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  // Get current posts
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.subcategories.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Define handleCloseEditModal, handleCloseCommentModal, handleCloseViewModal functions
  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  // Define handleEdit, handleComment, handleView functions
  const handleEdit = (subcategories) => {
    setEditedSubcategory(subcategories);
    setShowEditModal(true);
  };

  // Define handleSaveEditedSmartGoal function

  return (
    <div>
      <div className="row border-1">
        <div className="col-lg-6">
          <h4 className="text-start pb-3"> Sub Category List</h4>
        </div>
        <div className="col-lg-6 text-end bg-white ">
          <a href="subcategorymain" className="text-decoration-none text-white">
            <button type="button" class="btn btn-danger rounded-pill">
              Add Subcategory
            </button>
          </a>
        </div>
      </div>
      <ReactBootstrap.Table striped bordered hover size="sm">
        <thead className="text-center">
          <tr>
            {/* <th>#</th> */}
            <th>#</th>
            <th>Primary Category</th>
            <th>Subcategory</th>
            {/* <th>SubCategory</th> */}
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.map((subcategories, index) => (
            <tr key={index}>
              {<td>{index + 1}</td>}
              <td>{subcategories.categoryname}</td>

              <td>{subcategories.subcategoryname}</td>

              {/* Action buttons */}
              <td className="text-center">
                <ReactBootstrap.Button
                  className="bg-transparent border-0"
                  onClick={() => handleEdit(subcategories)}
                >
                  <img src={Editbtn}></img>
                </ReactBootstrap.Button>
                {/* <ReactBootstrap.Button onClick={() => handleComment(skill)}>Comment</ReactBootstrap.Button> */}
                <ReactBootstrap.Button
                  className="bg-transparent border-0"
                  variant="danger"
                  onClick={() => handleDelete(subcategories.id)}
                >
                  <img src={deletebtn}></img>
                </ReactBootstrap.Button>
              </td>
            </tr>
          ))}
        </tbody>
      </ReactBootstrap.Table>

      {/* Delete confirmation modal */}
      <ReactBootstrap.Modal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
      >
        <ReactBootstrap.Modal.Header closeButton>
          <ReactBootstrap.Modal.Title>
            Confirm Deletion
          </ReactBootstrap.Modal.Title>
        </ReactBootstrap.Modal.Header>
        <ReactBootstrap.Modal.Body>
          Are you sure you want to delete this Subcategory?
        </ReactBootstrap.Modal.Body>
        <ReactBootstrap.Modal.Footer>
          <ReactBootstrap.Button
            variant="secondary"
            onClick={handleCloseDeleteModal}
          >
            Cancel
          </ReactBootstrap.Button>
          <ReactBootstrap.Button variant="danger" onClick={confirmDelete}>
            Delete
          </ReactBootstrap.Button>
        </ReactBootstrap.Modal.Footer>
      </ReactBootstrap.Modal>

      {/* Edit Modal */}
      {showEditModal && editedsubcateory && (
        <ReactBootstrap.Modal
          show={showEditModal}
          onHide={handleCloseEditModal}
        >
          <ReactBootstrap.Modal.Header closeButton>
            <ReactBootstrap.Modal.Title>SubCategory</ReactBootstrap.Modal.Title>
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body>
            {/* Editable form fields */}
            <div>
              <label>Subcategory Name :</label>
              <input
                type="text"
                value={editedsubcateory.subcategoryname}
                onChange={(e) =>
                  setEditedSubcategory({
                    ...editedsubcateory,
                    subcategoryname: e.target.value,
                  })
                }
              />
            </div>

            {/* Add input fields for other attributes as needed */}
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer>
            <ReactBootstrap.Button
              variant="secondary"
              onClick={handleCloseEditModal}
            >
              Close
            </ReactBootstrap.Button>
            {/* On clicking the Update button, call handleSaveEditedSmartGoal to save changes */}
            <ReactBootstrap.Button
              variant="primary"
              onClick={handleSaveEditedSubcategory}
            >
              Update
            </ReactBootstrap.Button>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal>
      )}

      {/* Pagination */}
      <ReactBootstrap.Pagination>
        {Array.from(
          { length: Math.ceil(posts.subcategories.length / postsPerPage) },
          (_, index) => (
            <ReactBootstrap.Pagination.Item
              key={index}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </ReactBootstrap.Pagination.Item>
          )
        )}
      </ReactBootstrap.Pagination>
    </div>
  );
};

export default SubCategoryTable;
